import { render, staticRenderFns } from "./DialogSuporte.vue?vue&type=template&id=c76d322c&scoped=true&"
import script from "./DialogSuporte.vue?vue&type=script&lang=js&"
export * from "./DialogSuporte.vue?vue&type=script&lang=js&"
import style0 from "./DialogSuporte.vue?vue&type=style&index=0&id=c76d322c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c76d322c",
  null
  
)

export default component.exports